import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';

import Collapse from '@mui/material/Collapse';
import Tooltip from '@mui/material/Tooltip';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import ListItemText from '@material-ui/core/ListItemText';

import { SidebarItemType, SidebarItemChildrenType } from 'src/interfaces/idashboard';
import { SidebarItemProps } from 'src/interfaces/iproptypes';

import useStyles from './styles';
import SidebarOption from './SidebarOption';
import { sampleMarket } from 'src/utils/const';
import { DEFAULT_TEXT_COLOR } from 'src/utils/colors';

const SidebarItem = ({
  item,
  isSubGroup,
  handleSidebarClick,
  handleSidebarListItemClick,
  matches,
  sidebarOpen,
  setSidebarOpen,
  index,
  selectedSidebarIndex,
  user,
  setOpenReportComparePage,
}: SidebarItemProps) => {
  const hasSubOptions = item.children ? item.children.length > 0 : false;

  const classes = useStyles();

  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  let isOptionGroupSelected: boolean = false;

  useEffect(() => {
    !sidebarOpen && setIsExpanded(false);
  }, [sidebarOpen]);

  if (hasSubOptions) {
    (item.children as SidebarItemChildrenType[]).forEach(data => {
      if (data.listIndex === selectedSidebarIndex) {
        isOptionGroupSelected = true;
      }
    });
  }

  return (
    <Tooltip
      placement={'right'}
      open={!matches && !sidebarOpen && isExpanded && item.children?.length > 0}
      onClose={() => !sidebarOpen && setIsExpanded(false)}
      leaveDelay={10}
      leaveTouchDelay={12000}
      title={
        <Card>
          <CardContent
            sx={{
              zIndex: 1000000,
              position: 'absolute',
              top: 0,
              left: 0,
              width: '150px',
              background: '#00839B',
              borderRadius: 2,
              boxShadow: '0 0 10px #0004',
            }}
          >
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={0}
              sx={{
                background:
                  item.listIndex === selectedSidebarIndex
                    ? 'rgba(34, 117, 116, 0.16)'
                    : 'transparent',
                padding: '2.5px 10px',
                paddingRight: '20px',
                borderRadius: 4,
              }}
            >
              <Stack spacing={2}>
                <>
                  <ListItemText
                    classes={{ primary: classes.sidebarText }}
                    primary={item.name}
                    onClick={() => {
                      if (item.name === 'Calculator') {
                        window.open('/airbnb-calculator', '_self');
                      }
                    }}
                    style={{
                      padding: '5px 10px',
                      width: '100px',
                      cursor: 'pointer',
                      borderWidth: '2px 2px 2px 2px',
                      borderStyle: 'solid',
                      borderColor: '#ffffff44',
                    }}
                  />
                  {(item.children as SidebarItemChildrenType[]).map(element => (
                    <>
                      {element?.chipLabel && (
                        <div className={classes.betaButtonShrinked}>{element.chipLabel}</div>
                      )}
                      <ListItemText
                        classes={{ primary: classes.sidebarText }}
                        primary={element.name}
                        style={{
                          padding: '5px 10px',
                          borderRadius: 4,
                          width: '100px',
                          background:
                            element.listIndex === selectedSidebarIndex ? '#0004' : 'inherit',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          if (element.redirectionLink) {
                            window.open(element.redirectionLink);
                            return;
                          }
                          if (
                            (window.location.pathname == '/airbnb-data' ||
                              window.location.pathname == '/airbnb-data/' ||
                              window.location.pathname == '/') &&
                            element.listIndex === 4
                          ) {
                            window.open(
                              `/airbnb-data/united-kingdom/0/${sampleMarket}?guests=true`,
                              '_self'
                            );
                          } else {
                            handleSidebarListItemClick(element.listIndex);
                            handleSidebarClick && handleSidebarClick(element.stateName);
                          }
                        }}
                      />
                    </>
                  ))}
                </>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      }
    >
      <div
        style={{
          backgroundColor: 'transparent',
          margin: '10px',
          borderRadius: 10,
          overflow: 'hidden',
          marginBottom: '2.5px',
        }}
        onClick={() => !sidebarOpen && setIsExpanded(true)}
        onMouseEnter={() => {
          if (!sidebarOpen) {
            setIsExpanded(true);
          }
        }}
      >
        <>
          <SidebarOption
            item={item}
            isSubGroup={isSubGroup}
            handleSidebarClick={handleSidebarClick}
            handleSidebarListItemClick={handleSidebarListItemClick}
            matches={matches}
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            index={index}
            selectedSidebarIndex={selectedSidebarIndex}
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
            user={user}
            setOpenReportComparePage={setOpenReportComparePage}
          />

          <Collapse in={isExpanded && sidebarOpen}>
            {hasSubOptions &&
              (item.children as SidebarItemChildrenType[]).map((data, index) => (
                <SidebarOption
                  item={data}
                  isSubGroup={true}
                  handleSidebarClick={handleSidebarClick}
                  handleSidebarListItemClick={handleSidebarListItemClick}
                  matches={matches}
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                  index={index}
                  selectedSidebarIndex={selectedSidebarIndex}
                  user={user}
                  setOpenReportComparePage={setOpenReportComparePage}
                />
              ))}
          </Collapse>
        </>
      </div>
    </Tooltip>
  );
};

export default SidebarItem;
